export default __webpack_public_path__ + "static/char-s-49-zh-Hant-b89afc26628dce5212a228151a96c8f0.png";